import React from 'react'
import Footer from '../components/Footer'
import Form from '../components/Form'
import HeroImgProject from '../components/HeroImgProject'
import Navbar from '../components/Navbar'

const Contact = () => {
  return (
    <div>
      <Navbar />
      <HeroImgProject heading="CONTACT" text="Let's have a chat"/>
      <Form />
      <Footer />
    </div>
  )
}

export default Contact